export default "__VITE_ASSET__BYU0hTZ9__"